import React, { FC, useEffect, useState } from 'react'
import { Col, Container, Nav, ProgressBar, Row, Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import MssqlTaskService from '../service/MssqlTaskService'
import MssqlDatabase from './MssqlDatabase'
import MssqlStatus from './MssqlStatus'
import MssqlUser from './MssqlUser'

const MssqlAdapter: FC<{}> = () => {
  const { t } = useTranslation()
  const [taskStatus, setTaskStatus] = useState({} as any)

  useEffect(() => {
    function getStatus() {
      MssqlTaskService.getStatus().then((taskStatus) => {
        setTaskStatus(taskStatus)
        setTimeout(getStatus, 10000)
      })
    }
    getStatus()
  }, [])

  return (
    <>
      {taskStatus?.taskProgress?.totalProgress !== undefined && taskStatus?.taskProgress?.totalProgress !== 100 && (
        <div className='h-100 d-flex align-items-center'>
          <Container>
            <Row>
              <Col className='text-center'>
                <h2>{t('mssqlAdapter.taskInProgress')}</h2>
              </Col>
            </Row>
            <br />
            <Row>
              <Col className='text-center'>
                <h3>{t('mssqlAdapter.overallTaskStatus')}</h3>
              </Col>
            </Row>
            <Row>
              <Col></Col>
              <Col xs={10}>
                <ProgressBar
                  now={taskStatus?.taskProgress?.totalProgress}
                  striped
                  animated
                  variant='success'
                  label={`${Math.min(taskStatus?.taskProgress?.totalProgress, 100)}%`}
                />
              </Col>
              <Col></Col>
            </Row>
            <br />
            <br />

            <Row>
              <Col className='text-center'>
                <h4>{taskStatus?.taskProgress?.currentStepName}</h4>
              </Col>
            </Row>
            <Row>
              <Col></Col>
              <Col xs={10}>
                <ProgressBar
                  now={taskStatus?.taskProgress?.currentStepProgress}
                  striped
                  animated
                  variant='success'
                  label={`${Math.min(taskStatus?.taskProgress?.currentStepProgress)}%`}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
      )}
      {taskStatus?.taskProgress?.totalProgress !== undefined && taskStatus?.taskProgress?.totalProgress === 100 && (
        <Tab.Container id='mssql-adapter-tab' defaultActiveKey='status'>
          <Nav variant='tabs'>
            <Nav.Item>
              <Nav.Link eventKey='status'>{t('mssqlAdapter.status')}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey='databases'>{t('mssqlAdapter.databases')}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey='users'>{t('mssqlAdapter.users')}</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey='status'>
              <MssqlStatus />
            </Tab.Pane>
            <Tab.Pane eventKey='databases'>
              <MssqlDatabase />
            </Tab.Pane>
            <Tab.Pane eventKey='users'>
              <MssqlUser />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      )}
    </>
  )
}

export default MssqlAdapter
